import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import Icon from '../../core/Icon';
import { FormatTxt } from '../../core/FormatTxt';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import TitleWidget from '../../core/TitleWidget';
import { ContentGrouping } from '../../core/ContentGrouping';
import Buttons from '../../core/Buttons';

export const StyledLoadingContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
`;

export const StyledBoxPrincipal = styled.div`
  background: ${props => props.theme.colors.grayLightest};
  padding: ${rem('20px')} ${rem('20px')} ${rem('96px')};
  ${rem('20px')};
  width: 100%;
  height: ${rem('400px')};
`;

export const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${rem('10px')};
`;

export const StyledText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  color: ${props => props.theme.colors.dark};
  font-size: ${rem('14px')};
  font-weight: 400;
  margin-bottom: 0;
  max-width: ${rem('500px')};
`;

export const StyledFullScreenIcon = styled(Icon)`
  cursor: pointer;
  display: none;
  ${mediaqueries.greaterThan('desktop')`
    display: block;
  `};
`;

export const StyledChannelLogosWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const StyledIcon = styled(Icon)`
  height: ${rem('16px')};
  ${mediaqueries.greaterThan('mobile')`
    width: ${rem('30px')};
    height: ${rem('26px')};;
  `};
`;

export const StyledTooltipWrapper = styled.div`
  background: ${props => props.theme.colors.light};
  border: 1px solid ${props => props.theme.colors.dark};
  padding: ${rem('20px')};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const StyledTooltipTopTxt = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const StyledTooltipBottomTxt = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledTooltipChannelTxt = styled.span`
  font-size: ${rem('11px')};
  text-transform: uppercase;
  margin-left: ${rem('7px')};
  font-weight: 700;
`;

export const StyledTooltipFixedTxt = styled.span`
  font-size: ${rem('11px')};
  margin-right: ${rem('5px')};
`;

export const StyledTooltipShareTxt = styled.span`
  font-size: ${rem('12px')};
  font-weight: 700;
`;

export const StyledTitleWidget = styled(TitleWidget)`
  margin-bottom: ${rem('35px')};
  margin-left: ${rem('22px')};

  svg {
    width: ${rem('51px')};
    height: ${rem('47px')};
    top: ${rem('-9px')};
  }

  ${mediaqueries.greaterThan('tablet')`
    line-height: ${rem('31px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('54px')};

    svg{
      width: ${rem('51px')};
      height: ${rem('47px')};
      top: ${rem('-8px')};
    }
  `};
`;

export const WrapperFlex = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${rem('297px')};
  margin: 0 auto;
  ${mediaqueries.greaterThan('tablet')`
    max-width: ${rem('584px')};
  `};
  ${mediaqueries.greaterThan('desktop')`    
    max-width: ${rem('1203px')};
    margin: 0;
  `};
`;

export const WrapperModule = styled.div`
  width: 100%;
  margin-bottom: ${rem('35px')};

  ${mediaqueries.greaterThan('desktop')`    
    margin-bottom: ${rem('51px')};   
  `};
`;

export const WrapperModuleSearch = styled(WrapperModule)`
  position: relative;
  z-index: 30;
  margin-bottom: ${rem('10px')};
  ${mediaqueries.greaterThan('mobile')`
     margin-bottom: ${rem('50px')};
  `};
`;

export const WrapperModuleAudience = styled(WrapperModule)`
  position: relative;
`;

export const WrapperModuleReports = styled(WrapperModule)`
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('562px')};
  `};
`;

export const Wrapper2Col = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('75px')};
  `};
`;

export const StyledCol = styled.div`
  width: 100%;
  margin-bottom: ${rem('35px')};

  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('562px')};
    margin-bottom: ${rem('50px')};
  `};
`;

export const StyledBackBtn = styled(Link)`
  display: flex;
  align-items: center;
  width: ${rem('100px')};
  font-size: ${props => props.theme.fontSize.medium};
  font-family: ${props => props.theme.fonts.bold};
  color: ${props => props.theme.colors.dark};
  margin-bottom: ${rem('35px')};
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

export const StyledBackBtnIcon = styled(Icon)`
  margin-right: ${rem('5px')};
`;

export const StyledWrapper = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  display: flex;
`;

export const StyledNumber = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLighter};
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  border-top: ${rem('1px')} solid ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.grayDark};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  justify-content: center;
  width: ${rem('26px')};
  height: ${rem('38px')};
  font-size: ${rem('13px')};
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${rem('15px')};
  `};
`;

export const StyledLogo = StyledNumber.extend`
  background-color: transparent;
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  width: ${rem('43px')};
`;

export const StyledName = StyledLogo.extend`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  color: ${props => props.theme.colors.dark};
  display: block;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('13px')};
  justify-content: left;
  line-height: 2.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90.2%;
  padding-right: ${rem('20px')};
  ${mediaqueries.greaterThan('tablet')`
    width: 83.7%;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: 65%;
  `};
`;

export const StyledData = styled.div`
  display: none;
  align-items: center;
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  border-top: ${rem('1px')} solid ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  justify-content: flex-end;
  padding-right: ${rem('20px')};
  width: ${rem('64px')};

  &:last-child {
    border-bottom: ${rem('1px')} solid
      ${props => props.theme.colors.grayLighter};
  }

  ${mediaqueries.greaterThan('tablet')`
    display: flex;
  `};
`;

export const StyledRankingIcon = styled(Icon)`
  width: ${rem('23px')};
  height: ${rem('23px')};
`;

export const StyledReportList = styled.ul`
  background-color: ${props => props.theme.colors.grayMoreLight};
  border-left: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  border-right: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  border-top: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const StyledReportListItem = styled.li`
  background-color: ${props => props.theme.colors.grayMoreLight};
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  font: ${rem('14px')} / ${rem('14px')} ${props => props.theme.fonts.book};
  overflow: hidden;
  padding: ${rem('9px')} ${rem('20px')};
  position: relative;
  &:before {
    display: none;
  }
`;

export const StyledSpan = styled.span`
  flex-grow: 1;
  line-height: ${rem('20px')};
`;

export const StyledIconShare = styled(Icon)`
  fill: ${props => props.theme.colors.light};
  ${mediaqueries.greaterThan('mobile')`
      fill: ${props => props.theme.colors.dark};
      margin-left:  ${rem('10px')};
  `};
`;

export const StyledIconNav = styled(Icon)`
  background: none;
  border: none;
  float: right;

  ${mediaqueries.greaterThan('mobile')`
      display: none;
  `};
`;

export const StyleReportBtnWrapper = styled.div`
  width: ${rem('200px')};
  align-items: center;
  display: flex;
  justify-content: space-around;
  padding: ${rem('8px')} 0;
  position: absolute;
  right: 0;
  top: ${rem('-43px')};
  transition: 0.5s;

  ${mediaqueries.greaterThan('mobile')`
    top: 0;
    justify-content: flex-start;
    width: auto;
    margin-right: ${rem('10px')};
  `};

  ${mediaqueries.lessThan('mobile')`
      ${props =>
        props.active &&
        css`
          background-color: ${props => props.theme.colors.dark};
          box-shadow: 0 ${rem('1px')} ${rem('3px')} 0 rgba(0, 0, 0, 0.5);
          top: 0;
        `};
  `};
`;

export const StyledFormatTxt = styled(FormatTxt)`
  ${mediaqueries.greaterThan('mobile')`
      margin-left:  ${rem('10px')};
  `};
`;

export const StyledContentGrouping = styled(ContentGrouping)``;

export const StyledMonthAudience = styled.div`
  background-color: ${props => props.theme.colors.grayMoreLight};
  border: ${rem('1px')} ${props => props.theme.colors.grayLighter} solid;
  overflow: hidden;
  position: relative;
  width: ${rem('299px')};
  ${mediaqueries.greaterThan('tablet')`
    width: ${rem('584px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    overflow-x: hidden;
    width: auto;
  `};
`;

export const StyledDays = styled.div`
  background-color: ${props => props.theme.colors.grayLighter};
  display: flex;
  left: 0;
  padding-left: 0;
  position: absolute;
  top: 0;
  z-index: 20;
  ${mediaqueries.greaterThan('desktop')`
    top: ${rem('44px')};
    padding-left: 0;
  `};
`;

export const StyledMaskOl = styled.div`
  max-width: ${rem('194px')};
  overflow: hidden;
  margin-left: ${rem('75px')};
  margin-right: ${rem('28px')};
  ${mediaqueries.greaterThan('tablet')`
    max-width: ${rem('479px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: inherit;
    overflow: visible;
    margin-left: 0;
    margin-right: 0;
  `};
`;

export const StyledOl = styled.ol`
  display: flex;
  left: 0;
  position: relative;
  transition: transform 0.5s ease-in-out;
  min-width: ${rem('242px')};
  padding-left: 0;
  ${props =>
    props.xSlide &&
    css`
      transform: translateX(${props.xSlide}px);
    `};
  ${mediaqueries.greaterThan('tablet')`
    min-width: ${rem('477px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    flex-direction: column;
    transform: translateX(0);
    min-width: inherit;
  `};
`;

export const StyledItem = styled.li`
  border-left: ${rem('2px')} solid ${props => props.theme.colors.grayLightest};
  display: flex;
  justify-content: center;
  min-width: ${rem('48px')};
  padding-bottom: ${rem('3px')};
  padding-left: 0;
  padding-top: ${rem('10px')};
  text-align: center;
  &:last-child {
    border-right: ${rem('2px')} solid
      ${props => props.theme.colors.grayLightest};
  }
  &:before {
    display: none;
  }
  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    border-bottom: 1px solid ${props => props.theme.colors.grayLighter};
    border-left: none;
    border-top: 1px solid ${props => props.theme.colors.grayMoreLight};
    height: ${rem('38px')};
    min-width: ${rem('30px')};
    padding: 0;
    &:first-child{
      border-top: none;
    }
    &:last-child{
      border-bottom: none;
    }
  `};
`;

export const StyledTime = styled.time`
  display: flex;
  flex-direction: column;
`;

export const StyledWeekDay = styled.span`
  color: ${props => props.theme.colors.grayDarkest};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('11px')};
  line-height: ${rem('12px')};
  margin-bottom: ${rem('1px')};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('9px')};
    margin-bottom: 0;
    padding-top: ${rem('6px')}; 
  `};
`;

export const StyledDay = styled.span`
  color: ${props => props.theme.colors.grayDarkest};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  line-height: ${rem('15px')};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('13px')};
  `};
`;

export const StyledChannel = styled.div`
  background-color: ${props => props.theme.colors.grayMoreLight};
  left: 0;
  position: absolute;
  text-align: center;
  top: ${rem('41px')};
  width: ${rem('55px')};
  z-index: 3;
  ${mediaqueries.greaterThan('desktop')`
    left: ${rem('30px')};
    top: ${rem('1px')};
    width: auto;
  `};
`;

export const StyledListChannel = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
  ${mediaqueries.greaterThan('desktop')`
    flex-direction: row;
  `};
`;

export const StyledItemChannel = styled.li`
  align-items: center;
  border-bottom: ${rem('1px')} ${props => props.theme.colors.grayLighter} solid;
  display: flex;
  height: ${rem('39px')};
  justify-content: flex-start;
  padding-left: ${rem('15px')};
  vertical-align: middle;
  ${props =>
    props.columnHover &&
    css`
      background-color: ${props => props.theme.colors.grayLighter};
    `};

  &:before {
    display: none;
  }
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('45px')};
    width: ${rem('39px')};
    padding-left: ${rem('6px')};
  `};
`;

export const StyledRowGroup = styled.div`
  padding-left: ${rem('56px')};
  padding-top: ${rem('41px')};
  position: relative;
  transition: transform 0.5s ease-in-out;
  ${props =>
    props.xSlide &&
    css`
      transform: translateX(${props.xSlide}px);
    `};

  ${mediaqueries.greaterThan('desktop')`    
    display: flex;
    padding-left: ${rem('30px')};
    padding-top: ${rem('46px')};
    position: static;
    transform: translateX(0);    
  `};
`;

export const StyledCarousel = styled.div`
  overflow: hidden;
  position: relative;
  z-index: 2;

  &:before {
    box-shadow: inset 6px 0px 6px -3px rgba(196, 196, 196, 0.8);
    content: '';
    height: 100%;
    position: absolute;
    left: ${rem('55px')};
    top: 0;
    width: ${rem('20px')};
    z-index: 20;

    ${mediaqueries.greaterThan('desktop')`   
      display: none;
      box-shadow: none;
  `};
  }

  &:after {
    box-shadow: inset -6px 0px 6px -3px rgba(196, 196, 196, 0.8);
    content: '';
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: ${rem('20px')};
    z-index: 20;

    ${mediaqueries.greaterThan('desktop')`   
      display: none;
      box-shadow: none;
  `};
  }

  ${mediaqueries.greaterThan('desktop')`   
      overflow: visible;
  `};
`;

export const StyledCell = styled.div`
  align-items: center;
  display: flex;
  font-size: ${rem('14px')};
  height: ${rem('38px')};
  justify-content: center;
  text-align: center;
  width: ${rem('48px')};
  padding-left: ${rem('39px')};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('38px')}; 
    width: ${rem('38px')};
    padding-left: 0;
    border-bottom: ${rem('1px')} ${props =>
    props.theme.colors.grayLighter} solid;
    &:last-child{
      border: none;
    }
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('40px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('38px')};
  `};
`;

export const StyledRow = styled.div`
  border-bottom: ${rem('1px')} ${props => props.theme.colors.grayLighter} solid;
  display: flex;
  width: ${rem('1500px')};

  ${props =>
    props.columnHover &&
    css`
      background-color: ${props => props.theme.colors.grayLighter};
    `};

  ${mediaqueries.greaterThan('desktop')`
    border-bottom: none;
    flex-direction: column;
    transform: translateX(0);
    width: ${rem('39px')};
  `};
`;

export const StyledButtonPrev = styled(Buttons)`
  padding-left: 0;
  padding-right: 0;
  position: absolute;
  top: 0;
  left: ${rem('44px')};
  width: ${rem('28px')};
  height: ${rem('1212px')};
  & > svg {
    position: absolute;
    top: ${rem('12px')};
    left: ${rem('-3px')};
  }
  ${props =>
    !props.activePrevButton &&
    css`
      display: none;
    `};
  ${mediaqueries.greaterThan('desktop')`
    display: none;
  `};
`;

export const StyledButtonNext = styled(Buttons)`
  padding-left: 0;
  padding-right: 0;
  position: absolute;
  top: 0;
  right: 0;
  width: ${rem('28px')};
  height: ${rem('1212px')};
  & > svg {
    position: absolute;
    top: ${rem('12px')};
    right: ${rem('-3px')};
  }

  ${props =>
    !props.activeNextButton &&
    css`
      display: none;
    `};
  ${mediaqueries.greaterThan('desktop')`
    display: none;
  `};
`;

export const StyledMediaMonth = styled.span`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${rem('10px')};
  text-transform: uppercase;
`;
